/* eslint-disable prefer-destructuring */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/* eslint-disable radix */
/* eslint-disable no-lonely-if */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/button-has-type */
/* eslint-disable react/no-unknown-property */
/* eslint-disable arrow-body-style */
import React, { useMemo, useEffect, useState, useRef } from 'react';
import { Backdrop, CircularProgress, Box, Typography } from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import helper from '../../../../../../../utils/helper';
import trialAndStripeSubscriptionService from '../../../../../../../services/trialAndStripeSubscriptionService';
import subscriptionServices from '../../../../../../../services/subscriptionServices';
import { openSnackbar } from '../../../../../../../store/reducer';
import { getSatDetails } from '../../../../../../../Redux/Action';

const TIER_HIERARCHY = ['BASIC', 'PRO', 'PREMIUM'];

const tierIndex = (tier) => TIER_HIERARCHY.indexOf((tier || '').toUpperCase());

const CheckIcon = () => (
  <svg
    className="w-4 h-4 text-emerald-500 mt-0.5 shrink-0"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2.5}
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>
);

const ChevronIcon = ({ open }) => (
  <svg
    className={`w-4 h-4 text-gray-400 transition-transform duration-300 ${open ? 'rotate-180' : ''}`}
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
  </svg>
);

const Spinner = ({ className = 'h-4 w-4 text-white' }) => (
  <svg
    className={`animate-spin ${className}`}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z" />
  </svg>
);

const PlanDetails = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const allcourseDetails = useSelector((state) => state);
  const userid = useSelector((state) => state.userInfo?.id);
  const storeInfo = useSelector((state) => state);

  const rawSatDetails = location.state?.satDetails;
  const satDetails = useMemo(() => {
    if (Array.isArray(rawSatDetails)) return rawSatDetails;
    if (rawSatDetails) return [rawSatDetails];
    return [];
  }, [rawSatDetails]);

  const [planDetails, setPlanDetails] = useState([]);
  const [loadingPlanId, setLoadingPlanId] = useState(null);
  const [prorationMap, setProrationMap] = useState({});
  const [confirmDialog, setConfirmDialog] = useState({ open: false, plan: null, proration: null });
  const [upgradeLoading, setUpgradeLoading] = useState(false);
  const [openExam, setOpenExam] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const currency = storeInfo?.userInfo?.currencyType?.code || 'USD';
  const prorationFetched = useRef(false);

  // ─── Proration dialog values ───────────────────────────────────────────────
  const proration = confirmDialog?.proration;

  let difference = 0;
  let newCost = 0;

  if (proration?.nextAmount) {
    newCost = Number(proration.nextAmount);
    const currentPrice = Number(proration.currentPlanPrice || 0);
    // Prefer server-calculated prorated amount; fall back to (new - old) if unavailable
    difference = proration.amount != null
      ? Number(proration.amount)
      : Math.max(0, newCost - currentPrice);
  }
  // ──────────────────────────────────────────────────────────────────────────

  useEffect(() => {
    getPlanDetails();
  }, []);

  const getPlanDetails = async () => {
    setIsLoading(true);
    const res = await subscriptionServices.getAssessmentplandetails();
    if (res.ok) {
      setIsLoading(false);
      setPlanDetails(res.data);
    }
  };


  const isExpired = (validTo) => {
    
    if (!validTo) return false;
    return new Date() > new Date(validTo);
  };

  const activeAssessmentIds = useMemo(() => {
    const ids = new Set();
    satDetails.forEach((item) => {
      if (item?.subscription_status === 'ACTIVE' && item?.id) {
        ids.add(item.id);
      }
      (item?.subscribed_plans || []).forEach((sp) => {
        if (sp.status === 'ACTIVE' && item?.id) ids.add(item.id);
      });
    });
    return ids;
  }, [satDetails]);
  
  const activePlatformPlanIds = useMemo(() => {
    const ids = new Set();
    satDetails.forEach((item) => {
      if (item?.subscription_status === 'ACTIVE' && item?.subscribed_plan_id) {
        const parentValidTo = item?.valid_to;
        if (!isExpired(parentValidTo)) {
          ids.add(item.subscribed_plan_id);
        }
      }
      (item?.subscribed_plans || []).forEach((sp) => {
        if (sp.status === 'ACTIVE') {
          const childValidTo = sp?.valid_to;  
          if (!isExpired(childValidTo)) {
            ids.add(sp.subscriptionPlanId);
          }
        }
      });
    });
    return ids;
  }, [satDetails]);

  const platformActiveTier = useMemo(() => {
    let highestIdx = -1;
    planDetails
      .filter((p) => p.scope === 'platform' && activePlatformPlanIds.has(p.id))
      .forEach((p) => {
        const idx = tierIndex(p.tier);
        if (idx > highestIdx) highestIdx = idx;
      });
    return highestIdx >= 0 ? TIER_HIERARCHY[highestIdx] : null;
  }, [planDetails, activePlatformPlanIds]);

  

  const activeCategoryPlanIds = useMemo(() => {
    const ids = new Set();
    satDetails.forEach((item) => {
      (item?.subscribed_plans || []).forEach((sp) => {
        if (sp.status === 'ACTIVE') {
          ids.add(sp.subscriptionPlanId);
        }
      });
    });
    return ids;
  }, [satDetails]);

  const categoryActiveTierByType = useMemo(() => {
    const result = {};
    planDetails
      .filter((p) => p.scope === 'category' && p.type && activeCategoryPlanIds.has(p.id))
      .forEach((p) => {
        const idx = tierIndex(p.tier);
        const bestIdx = tierIndex(result[p.type]);
        if (idx > bestIdx) {
          result[p.type] = p.tier.toUpperCase();
        }
      });
    return result;
  }, [planDetails, activeCategoryPlanIds]);

  // ─── Price helper ──────────────────────────────────────────────────────────

  const getPrice = (data) => {
    const filtered = data?.stripePricingList?.filter((item) =>
      allcourseDetails?.currency === 'USD'
        ? item?.related_currency_type_lk === 2
        : item?.related_currency_type_lk === 1
    );
    return filtered?.[0]?.value ?? filtered?.[0]?.value;
  };

  // ─── Current active plan helpers ──────────────────────────────────────────

  /**
   * Returns the plan object that is currently active for the platform scope
   * (i.e. the plan whose tier matches platformActiveTier).
   */
  const currentActivePlatformPlan = useMemo(() => {
    if (!platformActiveTier) return null;
    return (
      planDetails.find(
        (p) =>
          p.scope === 'platform' &&
          p.tier?.toUpperCase() === platformActiveTier.toUpperCase() &&
          activePlatformPlanIds.has(p.id)
      ) || null
    );
  }, [planDetails, platformActiveTier, activePlatformPlanIds]);
  


  const getCurrentActiveCategoryPlan = (examType) => {
    const activeTier = categoryActiveTierByType[examType];
    if (!activeTier) return null;
    return (
      planDetails.find(
        (p) =>
          p.scope === 'category' &&
          p.type === examType &&
          p.tier?.toUpperCase() === activeTier.toUpperCase() &&
          activeCategoryPlanIds.has(p.id)
      ) || null
    );
  };

 
  const fetchProrationForPlan = async (plan, scope, currentActivePlan) => {
    setLoadingPlanId(plan.id);
    try {
      const res = await trialAndStripeSubscriptionService.previewSubscriptionUpgrade({
        newPlanId: plan.id,
        currencyType: currency,
        frequency: plan.related_duration_type_lk,
        currentPlanId: currentActivePlan?.id,
        userId:userid
      });

      const data = res.data;

      const currentPlanPrice = currentActivePlan ? Number(getPrice(currentActivePlan) || 0) : 0;

      const prorationData = {
        loading: false,
        amount: data.prorationAmount,           
        nextAmount: data.nextBillingAmount,     
        currentPlanPrice,        
        currentPlanId: currentActivePlan?.id ?? null,                
        symbol: data.currencySymbol || '$',
        billingCycleEnd: data.billingCycleEnd,
        error: null,
      };

      setProrationMap((prev) => ({ ...prev, [plan.id]: prorationData }));
      setConfirmDialog({ open: true, plan, proration: prorationData });
    } catch (err) {
      const errorProration = {
        loading: false,
        amount: null,
        nextAmount: null,
        currentPlanPrice: 0,
        symbol: '$',
        error: 'Unable to calculate upgrade cost',
      };
      setConfirmDialog({ open: true, plan, proration: errorProration });
    } finally {
      setLoadingPlanId(null);
    }
  };

  const handleUpgradeClick = (plan, scope, currentActivePlan) => {
    fetchProrationForPlan(plan, scope, currentActivePlan);
  };

  
  const handleConfirmUpgrade = async () => {
    const { plan,proration  } = confirmDialog;
    
    if (!plan) return;

    setUpgradeLoading(true);
    try {
      const res = await trialAndStripeSubscriptionService.upgradeSubscription({
        newPlanId: plan.id,
        currencyType: currency,
        frequency: plan.related_duration_type_lk,
        currentPlanId: proration?.currentPlanId ?? null, 
      });
      if (res.status === 200) {
        setConfirmDialog({ open: false, plan: null, proration: null });
        dispatch(openSnackbar('Plan upgraded successfully!'));
        dispatch(getSatDetails(userid));
        setTimeout(() => navigate('/auth/subscribe'), 1500);
      } else {
        dispatch(openSnackbar(res?.data?.message || 'Upgrade failed. Please try again.'));
      }
    } catch (err) {
      dispatch(openSnackbar(err?.response?.data?.message || 'Upgrade failed. Please try again.'));
    } finally {
      setUpgradeLoading(false);
    }
  };

  const postAssessmentSubscription = async (plan) => {
    setLoadingPlanId(plan.id);
    let impactClickId = '';
    try { impactClickId = await helper.getClickId(); } catch { /* noop */ }

    const payload = {
      userId: userid,
      currencyType: currency,
      planId: plan.id,
      frequency: plan?.related_duration_type_lk,
      impactClickId,
      type: 'assessment',
    };

    try {
      const res = await trialAndStripeSubscriptionService.createAssessmentSubscription(
        JSON.stringify(payload)
      );
      if (res.status === 303) {
        window.location = res.data.paymentUrl;
      } else {
        dispatch(openSnackbar(res?.data?.message || 'Failed to Subscribe. Please try again.'));
      }
    } catch {
      dispatch(openSnackbar('Failed to Subscribe. Please try again.'));
    } finally {
      setLoadingPlanId(null);
    }
  };

  // ─── renderButton ──────────────────────────────────────────────────────────
  /**
   * scope          : 'platform' | 'category'
   * currentActivePlan : plan object the user is currently subscribed to (for price diff)
   */
  const renderButton = (plan, activeTierStr, scope = 'platform', currentActivePlan = null) => {
    const thisIdx = tierIndex(plan.tier);
    const currentIdx = tierIndex(activeTierStr);

    if (activeTierStr && thisIdx === currentIdx) {
      return (
        <button
          disabled
          className="w-full mt-auto rounded-lg py-3 font-semibold text-base bg-zinc-100 text-zinc-400 cursor-not-allowed"
        >
          Current Plan
        </button>
      );
    }

    if (activeTierStr && thisIdx < currentIdx) {
      return (
        <button
          disabled
          className="mt-auto w-full border border-gray-300 text-gray-400 py-3 rounded-lg font-medium cursor-not-allowed"
        >
          Unable to Downgrade
        </button>
      );
    }

    if (activeTierStr && thisIdx > currentIdx) {
      return (
        <button
          onClick={() => handleUpgradeClick(plan, scope, currentActivePlan)}
          disabled={loadingPlanId !== null}
          className="mt-auto w-full bg-blue-600 text-white hover:opacity-90 py-3 rounded-lg font-medium transition flex items-center justify-center gap-2"
        >
          {loadingPlanId === plan.id
            ? <><Spinner /> Processing…</>
            : `Upgrade to ${plan.tier}`
          }
        </button>
      );
    }

    return (
      <button
        onClick={() => postAssessmentSubscription(plan)}
        disabled={loadingPlanId !== null}
        className="mt-auto w-full bg-blue-600 text-white hover:opacity-90 py-3 rounded-lg font-medium transition flex items-center justify-center gap-2"
      >
        {loadingPlanId === plan.id
          ? <><Spinner /> Processing…</>
          : 'Subscribe'
        }
      </button>
    );
  };
  
  const platformPlans = useMemo(
    () =>
      planDetails
        ?.filter((p) => p.scope === 'platform' && p.is_online === true && p.tier !== 'FREE')
        .sort((a, b) => tierIndex(a.tier) - tierIndex(b.tier)),
    [planDetails]
  );
  const categoryPlansByType = useMemo(() => {
    const grouped = {};
    planDetails
      .filter((p) => p.scope === 'category' && p.type && p.is_online === true && p.tier !== 'FREE')
      .forEach((p) => {
        grouped[p.type] = [...(grouped[p.type] || []), p];
      });
    Object.keys(grouped).forEach((key) => {
      grouped[key].sort((a, b) => tierIndex(a.tier) - tierIndex(b.tier));
    });
    return grouped;
  }, [planDetails]);
  


  const PlanCard = ({ plan, activeTierStr, examType }) => {
    const currentCategoryPlan = getCurrentActiveCategoryPlan(examType);

    return (
      <div className="relative flex flex-col rounded-2xl p-5 border transition-transform duration-200 hover:-translate-y-1 bg-white border-gray-200">
        {plan.is_popular && (
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 z-10">
            <span className="bg-gradient-to-r from-amber-400 to-orange-400 text-white text-xs font-bold px-4 py-1 rounded-full shadow-md whitespace-nowrap">
              Most Popular
            </span>
          </div>
        )}

        <h3 className="font-bold text-gray-900 text-lg">{plan.tier}</h3>
        {plan.tagline && (
          <p className="text-xs text-gray-400 mt-0.5 mb-4">{plan.tagline}</p>
        )}

        <div className="mb-1">
          <span className="text-3xl font-bold text-gray-900">
            {allcourseDetails?.currency === 'USD' ? '$' : '₹'}{getPrice(plan)}
          </span>
          <span className="text-sm text-gray-400">/month</span>
        </div>
        <p className="text-xs text-gray-400 mb-4">Billed monthly</p>

        <ul className="space-y-2 flex-1 mb-6">
          {(plan.feature_bullets || []).map((f, i) => (
            <li key={i} className="flex items-start gap-2 text-sm text-gray-600">
              <CheckIcon />
              {f}
            </li>
          ))}
        </ul>

        {renderButton(plan, activeTierStr, 'category', currentCategoryPlan)}
      </div>
    );
  };

  const ExamAccordion = ({ examType, examPlans, openExam, setOpenExam }) => {
    const open = openExam === examType;
    const activeTier = categoryActiveTierByType[examType] || null;

    return (
      <div className={`rounded-2xl border overflow-hidden shadow-sm bg-gray-50 transition-all duration-200 ${open ? 'border-blue-400 ring-2 ring-blue-100' : 'border-gray-200'}`}>
        <button
          onClick={() => setOpenExam((prev) => (prev === examType ? null : examType))}
          className="w-full flex items-center justify-between px-6 py-4 text-left"
        >
          <div className="flex items-center gap-3">
            <span className="font-bold text-gray-900 text-base">{examType}</span>
            {activeTier && (
              <span className="text-xs font-semibold bg-blue-100 text-blue-600 px-3 py-0.5 rounded-full">
                {activeTier} Active
              </span>
            )}
          </div>
          <div className="flex items-center gap-4">
            <span className="text-sm text-gray-400 hidden sm:block">
              {examPlans
                .map((p) => `${p.tier} ${allcourseDetails?.currency === 'USD' ? '$' : '₹'}${getPrice(p)}`)
                .join(' · ')}
            </span>
            <ChevronIcon open={open} />
          </div>
        </button>

        <div
          className={`transition-all duration-500 ease-in-out overflow-hidden ${open ? 'max-h-[1000px] opacity-100' : 'max-h-0 opacity-0'}`}
        >
          <div className="px-4 pb-6 pt-1">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              {examPlans.length > 0 ? (
                examPlans.map((plan) => (
                  <PlanCard
                    key={plan.id}
                    plan={plan}
                    activeTierStr={activeTier}
                    examType={examType}      
                  />
                ))
              ) : (
                <div className="col-span-3 flex flex-col items-center justify-center py-10 text-center">
                  <div className="text-4xl mb-3">📭</div>
                  <p className="text-gray-500 text-sm font-medium">No plans available for {examType}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };


  return (
    <div className="min-h-screen py-16 px-6">
      {isLoading ? (
        <Backdrop
          sx={{
            color: '#fff',
            zIndex: (theme) => theme.zIndex.drawer + 1,
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
          }}
          open
        >
          <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center">
            <CircularProgress color="primary" size={60} thickness={4} />
            <Typography variant="h6" sx={{ mt: 2, color: 'text.primary' }}>
              Loading Plans...
            </Typography>
          </Box>
        </Backdrop>
      ) : (
        <>
          {confirmDialog.open && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
              <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full mx-4">
                <h3 className="text-xl font-bold text-gray-800 mb-2">Confirm Upgrade</h3>
                <p className="text-gray-500 text-sm mb-5">
                  You are upgrading to{' '}
                  <span className="font-semibold text-gray-800">
                    {confirmDialog.plan?.name || confirmDialog.plan?.tier}
                  </span>
                </p>

                {confirmDialog.proration &&
                  !confirmDialog.proration.loading &&
                  !confirmDialog.proration.error && (
                    <div className="bg-blue-50 border border-blue-100 rounded-xl p-4 mb-6 space-y-2">
                
                      <div className="flex justify-between text-sm">
                        <span className="text-gray-600">Charged today (prorated)</span>
                        <span className="font-bold text-blue-800">
                          {proration.symbol}{(confirmDialog.proration.nextAmount - confirmDialog.proration.currentPlanPrice)?.toFixed(2)}
                        </span>
                      </div>

                      <div className="flex justify-between text-sm">
                        <span className="text-gray-600">From next billing cycle</span>
                        <span className="font-semibold text-gray-800">
                          {confirmDialog.proration.symbol}
                          {confirmDialog.proration.nextAmount?.toFixed(2)}/month
                        </span>
                      </div>

                      {confirmDialog.proration.billingCycleEnd && (
                        <p className="text-xs text-gray-400 pt-1">
                          Current cycle ends: {confirmDialog.proration.billingCycleEnd}
                        </p>
                      )}
                    </div>
                  )}

                {confirmDialog.proration?.error && (
                  <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-4 mb-6">
                    <p className="text-sm text-yellow-700">
                      ⚠️ Could not calculate exact upgrade cost. You will be charged the prorated
                      difference by Stripe.
                    </p>
                  </div>
                )}

                <div className="flex gap-3">
                  <button
                    onClick={() => setConfirmDialog({ open: false, plan: null, proration: null })}
                    disabled={upgradeLoading}
                    className="flex-1 py-3 rounded-lg border border-gray-300 text-gray-600 font-medium hover:bg-gray-50 transition"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleConfirmUpgrade}
                    disabled={upgradeLoading}
                    className="flex-1 py-3 rounded-lg bg-blue-600 text-white font-medium hover:opacity-90 transition flex items-center justify-center gap-2"
                  >
                    {upgradeLoading ? <><Spinner /> Upgrading…</> : 'Confirm Upgrade'}
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* ── Back button ── */}
          <button
            onClick={() => navigate('/auth/subscribe')}
            className="ml-6 text-sm flex items-center gap-2 hover:underline mt-5 mb-4"
          >
            <ArrowBackIcon fontSize="small" />
            Back to Test Series
          </button>

          {/* ── Hero ── */}
          <div className="text-center max-w-3xl mx-auto mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">Choose your plan</h2>
            <p className="text-gray-500 text-base mb-3">
              Unlock test series for SAT, JEE, NEET, and CLAT
            </p>
            <div className="flex items-center justify-center gap-2 bg-yellow-50 border border-yellow-300 px-4 py-2 rounded-md w-full max-w-lg mx-auto">
              <span>⚠️</span>
              <p className="text-amber-700 text-md text-center">
                Currently, you cannot downgrade your plan. Choose wisely.
              </p>
            </div>
          </div>

          {/* ── Platform Plans ── */}
          <div className="max-w-6xl mx-auto mb-4">
            <p className="text-xs font-semibold tracking-widest text-gray-400 uppercase">
              Platform Plans — All Exams
            </p>
          </div>

          <div className="grid gap-8 max-w-6xl mx-auto grid-cols-1 md:grid-cols-3 items-stretch">
            {platformPlans && platformPlans.length > 0 ? (
              platformPlans.map((plan) => (
                <div
                  key={plan.id}
                  className="w-full h-full bg-white rounded-2xl shadow-sm p-8 flex flex-col border"
                >
                  <h3 className="text-2xl font-bold text-gray-800">{plan.name}</h3>

                  <div className="mb-1">
                    <span className="text-3xl font-bold text-gray-900">
                      {allcourseDetails?.currency === 'USD' ? '$' : '₹'}{getPrice(plan)}
                    </span>
                    <span className="text-sm text-gray-400">/month</span>
                  </div>
                  <p className="text-xs text-gray-500 mt-1 mb-4">Billed monthly</p>

                  <ul className="space-y-3 text-sm text-gray-700 mb-8 flex-grow">
                    {(plan.feature_bullets || []).map((feature, index) => (
                      <li key={index} className="flex gap-3">
                        <span className="w-5 h-5 flex items-center justify-center rounded-full border-2 border-emerald-500 text-emerald-500 text-xs font-bold shrink-0">
                          ✓
                        </span>
                        {feature}
                      </li>
                    ))}
                  </ul>

                  {/*
                    Pass scope='platform' and the current active platform plan object
                    so renderButton can forward it to handleUpgradeClick → fetchProrationForPlan.
                  */}
                  {renderButton(plan, platformActiveTier, 'platform', currentActivePlatformPlan)}
                </div>
              ))
            ) : (
              <div className="col-span-3 flex flex-col items-center justify-center py-16 text-center border border-gray-200 rounded-2xl bg-gray-50">
                <div className="text-5xl mb-4">📭</div>
                <p className="text-gray-500 text-base font-medium">No platform plans available currently</p>
                <p className="text-gray-400 text-sm mt-1">Please check back later</p>
              </div>
            )}
          </div>

          {/* ── Category Plans ── */}
          <div className="max-w-6xl mx-auto mb-8 mt-16">
            <p className="text-lg font-semibold text-gray-800 mb-1">Category Plans — Exam Specific</p>
            <p className="text-gray-500 text-base">
              Focused plans for a single exam — AI-powered analytics, concept mastery, and personalised
              next steps. Each exam category is independently subscribed.
            </p>
          </div>

          <div className="grid gap-6 max-w-6xl mx-auto grid-cols-1">
            {Object.entries(categoryPlansByType).length > 0 ? (
              Object.entries(categoryPlansByType).map(([examType, examPlans]) => (
                <ExamAccordion
                  key={examType}
                  examType={examType}
                  examPlans={examPlans}
                  openExam={openExam}
                  setOpenExam={setOpenExam}
                />
              ))
            ) : (
              <div className="flex flex-col items-center justify-center py-16 text-center border border-gray-200 rounded-2xl bg-gray-50">
                <div className="text-5xl mb-4">📭</div>
                <p className="text-gray-500 text-base font-medium">No category plans available currently</p>
                <p className="text-gray-400 text-sm mt-1">Please check back later</p>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default PlanDetails;